
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 35 27","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"35","height":"27","data-name":"Vector Smart Object copy 27","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAbCAQAAABc+f4SAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLGwDLlTPmAAADRElEQVQ4y32VbUyWZRTHfyD48NKToKaBhog6FSdmTWHRlLaKXihtq9aWhZlbmx+MtSxbs7Ja9cWtN5yzDXULc6INW21RzZeyZRgkFiWZTFiJwgSawcjKXx98fJ6bhyfu8+mc87//13X9zznXhSSwffa5xztNSphNYImCOf5hoVX+YrNlo/wcHp1mndtFTPYRu9ziVQlJyu2KeUky4mvlczLJZ5AztFNODvfQHofJo5k2Sq+4ycOSubzICaYynhbepJY25nMdBfzEC4wL4ELUcZGmQCS6sYXust/3vGmEsHlu8JAXrHOZqSLucJ87XRWvzXQ/sNfnzB5F0AmutdluX3eTLYY94YIgTYob7PM1C0wRMcn1vuSj5ickK7Lab5xqyL8NBWka/MqZ4lnXRmie8lV32esnzk5IdblyrcFmwAPuFLHUCQFoiuk+b6+3xlFc6zte9CNn+aw1sXgyHSxmLPA156O6384ALdzGP7wVqEYRNZwklUJa+I4F3E96rFKFfmGnVU6M69B5llkcOf8s19nkOTeaE8nnW6s+OLxSS633T+td4w2mBzRY5BNu97Q9bvMuU8XsQDWLoqSBLh7PMm5hETPpZwAIE+Yk33OUQxznEhms5HHmc4QlIxs/eJDZEXEnO8MCc0yOZpJcaZcNLjdsjzNGn/BuKxMWONdPPW5pxHvXjSMxwdHcTwnF/BC33RLqaeQUheSSQQe/s5RZ/DUcFBzNJjr5kOxAZC57OUwWqfRTzSruZhO/MkAX2yj5P20ets7NfuYYcZJVNtntFiuCTR+xKa73tI0uvzLGweQc2x3rfuvc7QX3WBGZssSW4kO2ecSb42nSvGTIcdb69LDBiNWrzJfd7tZIDcNe72rPWOPVQViF34pjnJtw9aX+6M++4Wrvi0Se9JyYZZ3HgsDdrrHMFof82BvjSCo97wrHOD2gVJrTRGywNgbMcsiDnvUxM33Gbg9G7zrELx200yHPuSRugYl2uDfmrnDQV6KPRshKj9rtZstNE/Eap5kx4hJ72363OinWfplk0BPXenN4gHuZRyNHOEYrv9EHjGMKhRRzB5N5n2pOkfCBif+yKWUxC5lNHiFgkLO00cgBDvPvZch/LI9jIvWv5HYAAAAASUVORK5CYII="}})])
          )
        }
      }
    